import { useMemo } from "react";

/**
 * Count words in a text for the runner's word-count meter. A "word" is a
 * whitespace-delimited run of non-whitespace characters; an empty/whitespace
 * string is 0 words. Sibling to `use-sentence-count.ts`.
 */
export function countWords(text: string): number {
  const trimmed = text.trim();
  if (!trimmed) return 0;
  return trimmed.split(/\s+/).length;
}

export function useWordCount(text: string): number {
  return useMemo(() => countWords(text), [text]);
}
